import type { TenantLandingConfig } from '~/types/types'

/**
 * Shared helpers for the tenant public site (components/site/*): the pieces
 * that must not drift between layouts — YouTube embedding and social link
 * resolution. Fonts and colors now come from the site theme
 * (assets/css/site-themes.css).
 */

/** YouTube watch/short URL → embeddable URL, null for anything else. */
export function youtubeEmbed(url: string | null | undefined): string | null {
  if (!url) return null
  const m = url.match(/(?:youtube\.com\/(?:watch\?v=|embed\/)|youtu\.be\/)([\w-]+)/)
  return m ? `https://www.youtube.com/embed/${m[1]}` : null
}

export function socialLinks(landing: TenantLandingConfig): Array<{ icon: string, href: string }> {
  const items: Array<{ icon: string, href: string }> = []
  if (landing.social_facebook) items.push({ icon: 'i-lucide-facebook', href: landing.social_facebook })
  if (landing.social_twitter) items.push({ icon: 'i-lucide-twitter', href: landing.social_twitter })
  if (landing.social_instagram) items.push({ icon: 'i-lucide-instagram', href: landing.social_instagram })
  if (landing.social_youtube) items.push({ icon: 'i-lucide-youtube', href: landing.social_youtube })
  if (landing.social_linkedin) items.push({ icon: 'i-lucide-linkedin', href: landing.social_linkedin })
  return items
}
